<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <b-row class="mt-3" v-if="log && log.length">
      <b-col md="12">
        <b-table :items="log" :fields="fields" small></b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "stock-log",
  components: {},
  data() {
    return {
      log: null,
      fields: [
        { key: "date", label: "Date" },
        { key: "event", label: "Event" },
        { key: "comment", label: "Comment" },
        { key: "order_id", label: "Order" },
        { key: "qty", label: "Quantity" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Stock", to: { name: "stock" } },
        { text: "Logs #" + this.$route.params.id, active: true }
      ]
    };
  },
  mounted: function() {
    this.getLog();
  },
  methods: {
    getLog: function() {
      let loader = this.$loading.show();
      this.$http
        .get(this.APIURL + this.BRAND + "/log/" + this.$route.params.id)
        .then(
          response => {
            this.log = response.data;
            loader.hide();
          },
          error => {
            loader.hide();
            console.log(error);
          }
        );
    }
  }
};
</script>
